.title {
    font-weight: 700;
    margin-bottom: 1em;
}

.component {
    margin-bottom: 1em;
    break-inside: avoid;
}

.firstIngredientGroup {
    break-inside: avoid;
}

.componentTitle {
    font-weight: 700;
}

.ingredientsText {
    li {
        margin-top: 0;
        margin-bottom: 0;
    }
}
